export type ComposerKind = "price" | "custom" | "catalog";
export type ScheduleMode = "now" | "planned" | "interval" | "daily";

const scheduleOptions: Record<Exclude<ComposerKind, "catalog">, Array<{
  id: ScheduleMode;
  label: string;
  description: string;
}>> = {
  price: [
    { id: "now", label: "Сейчас", description: "Один выход" },
    { id: "interval", label: "По интервалу", description: "Каждые N минут" },
    { id: "daily", label: "Ежедневно", description: "По времени мск" }
  ],
  custom: [
    { id: "now", label: "Сейчас", description: "Один выход" },
    { id: "planned", label: "В дату", description: "Один раз" },
    { id: "interval", label: "По интервалу", description: "Каждые N минут" },
    { id: "daily", label: "Ежедневно", description: "По времени мск" }
  ]
};

export const scheduleModesForKind = (kind: ComposerKind) =>
  kind === "catalog" ? [] : scheduleOptions[kind];

export const composerSteps = (kind: ComposerKind) => {
  if (kind === "price") {
    return ["destination", "products", "price", "appearance", "schedule", "review"] as const;
  }
  if (kind === "custom") {
    return ["destination", "editor", "appearance", "schedule", "review"] as const;
  }
  return ["destination", "appearance", "review"] as const;
};
